import IAddress, { EmptyAddress } from "amnShared/addresses/models/IAddress";
import AddressIArea, {
  EmptyArea as AddressEmptyArea,
} from "amnShared/addresses/models/IArea";
import IStore from "./IStore";
import { NIL, v4 as uuid4 } from "uuid";
import { UseFormSetValue } from "react-hook-form";

function mapApiAreaToAddressArea(
  area?: Partial<AddressIArea> | null,
): AddressIArea {
  if (!area?.id || area.id === NIL) return AddressEmptyArea;

  return {
    id: area.id,
    name: area.name ?? "",
    subDivisionId: area.subDivisionId ?? NIL,
    subDivisionName: area.subDivisionName,
    subDivision: area.subDivision,
    countryId: area.countryId ?? NIL,
    countryName: area.countryName,
    country: area.country ?? "",
    code: area.code ?? "",
    isCountryActivated: area.isCountryActivated ?? false,
  };
}

export function mapApiAddressToForm(
  address?: Partial<IAddress> | null,
): IAddress | null {
  if (!address?.areaId && !address?.area?.id) return null;

  return {
    ...EmptyAddress,
    ...address,
    id: address.id && address.id !== NIL ? address.id : uuid4(),
    areaId: address.areaId ?? address.area?.id ?? NIL,
    area: mapApiAreaToAddressArea(address.area),
    clientId: undefined,
  };
}

export function syncStoreFromAddress(
  setStoreValue: UseFormSetValue<IStore>,
  address: IAddress,
) {
  setStoreValue(
    "address",
    {
      ...address,
      clientId: undefined,
    },
    { shouldDirty: true, shouldValidate: true },
  );
}

export function getStoreAddressLabel(store: IStore): string {
  const address = store.address;
  if (!address) return "";

  return [
    address.area?.countryName,
    address.area?.subDivisionName,
    address.area?.name,
    address.city,
    address.street,
    address.buildingNumber,
  ]
    .filter(Boolean)
    .join(", ");
}

export function hasStoreAddress(store: IStore): boolean {
  return Boolean(store.address?.area?.id && store.address.area.id !== NIL);
}

export function mapStoreAddressToDto(
  address?: IAddress | null,
): IAddress | null {
  if (!address?.areaId && !address?.area?.id) return null;

  const { clientId: _clientId, area, ...rest } = address;
  return {
    ...rest,
    areaId: address.areaId ?? area?.id ?? NIL,
    area:
      area?.id && area.id !== NIL
        ? area
        : AddressEmptyArea,
  };
}
